import React, { Component } from 'react';

class TextInputField extends Component {
    render() {

        let inputType = 'text';

        if (this.props.password) {
            inputType = 'password';
        } else if (this.props.email) {
            inputType = 'email';
        }if (this.props.number) {
            inputType = 'number';
        }

        // hasError

        const extraClass = this.props.hasError ? 'is-invalid' : '';
        if(this.props.textarea === undefined){
            if (this.props.disabled) {
                return (
                    <input
                        style={ this.props.style }
                        className={`form-control disabled ${extraClass} ${this.props.className} `}
                        id={`${this.props.field}_field`}
                        disabled={this.props.disabled}
                        contenteditable="true"
                        type={inputType}
                        value={this.props.value}
                        placeholder={this.props.placeholder}
                        onChange={(event) => {
                            this.props.onChange(this.props.field, event.target.value);
                        }}
                    />
                );
            } else {
                return (
                    <input
                        style={ this.props.style }
                        className={`form-control ${extraClass} ${this.props.className} `}
                        id={`${this.props.field}_field`}
                        disabled={this.props.disabled}
                        contenteditable="true"
                        type={inputType}
                        value={this.props.value}
                        placeholder={this.props.placeholder}
                        maxLength={this.props.maxLength}
                        onChange={(event) => {
                            this.props.onChange(this.props.field, event.target.value);
                        }}
                    />
                );
            }
            
        }
        else{
            return(
                <textarea 
                    className={`form-control ${extraClass} ${this.props.className} `}
                    style={ this.props.style }
                    disabled={this.props.disabled}
                    value={this.props.value}
                    placeholder={this.props.placeholder}
                    rows={ this.props.row }
                    onChange={(event) => {
                        this.props.onChange(this.props.field, event.target.value);
                    }}
                    >
                        
                </textarea>
            )
        }
    }
}

export default (TextInputField);
